export default __webpack_public_path__ + "static/media/DG_uml.9aab6ffb.png";